module.exports = __webpack_public_path__ + "static/media/bidirectional.9890df83.jpg";